export default __webpack_public_path__ + "static/media/b2.849c2e65.png";